export enum Breakpoints {
    MOBILE = 375,
    TABLET = 600,
    DESKTOP = 1024,
}
